import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-dialog-enrolment-patient-mmg-notes',
  templateUrl: './dialog-enrolment-patient-mmg-notes.html',
  styleUrls: ['./dialog-enrolment-patient-mmg-notes.scss'],
  standalone: false,
})

export class DialogEnrolmentPatientMmgNotes implements OnInit {

  @Input() mmgNotes: string = '';

  notes: string = '';

  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void {
    this.notes = this.mmgNotes;
  }

  onClose(): void {
    // Close the dialog logic here
    this.modalCtrl.dismiss();
  }

}
